import FreeProducts from 'merchandise-lib/constants/FreeProduct';
import Products from 'merchandise-lib/constants/Product';
import { isValidApiName } from './typeguards';
export const SkuCategoryNameToProductLineMap = {
  MARKETING_PRODUCTS: {
    freeHighlightedProduct: FreeProducts.MARKETING_HUB_FREE,
    paidHighlightedProducts: [Products.MARKETING_HUB_STARTER, Products.MARKETING_HUB_PROFESSIONAL, Products.MARKETING_HUB_ENTERPRISE]
  },
  SALES_PRODUCTS: {
    freeHighlightedProduct: FreeProducts.SALES_HUB_FREE,
    paidHighlightedProducts: [Products.SALES_HUB_STARTER, Products.SALES_HUB_PROFESSIONAL, Products.SALES_HUB_ENTERPRISE]
  },
  SERVICE_HUB_PRODUCTS: {
    freeHighlightedProduct: FreeProducts.SERVICE_HUB_FREE,
    paidHighlightedProducts: [Products.SERVICE_HUB_STARTER, Products.SERVICE_HUB_PROFESSIONAL, Products.SERVICE_HUB_ENTERPRISE]
  },
  CMS_HUB_PRODUCTS: {
    freeHighlightedProduct: FreeProducts.CMS_HUB_FREE,
    paidHighlightedProducts: [Products.CMS_HUB_STARTER, Products.CMS_HUB_PROFESSIONAL, Products.CMS_HUB_ENTERPRISE]
  },
  OPERATIONS_HUB_PRODUCTS: {
    freeHighlightedProduct: FreeProducts.OPERATIONS_HUB_FREE,
    paidHighlightedProducts: [Products.OPERATIONS_HUB_STARTER, Products.OPERATIONS_HUB_PROFESSIONAL, Products.OPERATIONS_HUB_ENTERPRISE]
  }
};
export const FREE_PRODUCTS = [FreeProducts.MARKETING_HUB_FREE, FreeProducts.SERVICE_HUB_FREE, FreeProducts.OPERATIONS_HUB_FREE, FreeProducts.CMS_HUB_FREE, FreeProducts.SALES_HUB_FREE, FreeProducts.HUBSPOT_FREE];
export const isFreeProduct = apiName => {
  return FREE_PRODUCTS.includes(apiName);
};
export const getHighlightedProductsForSkuCategory = ({
  skuCategoryName
}) => {
  var _productsMetadata$pai;
  const productsMetadata = SkuCategoryNameToProductLineMap[skuCategoryName];
  const paidHighlightedProducts = productsMetadata === null || productsMetadata === void 0 || (_productsMetadata$pai = productsMetadata.paidHighlightedProducts) === null || _productsMetadata$pai === void 0 ? void 0 : _productsMetadata$pai.filter(isValidApiName);

  // @ts-expect-error - sales-hub-free and operations-hub-free are not valid ProductApiName values yet
  const freeHighlightedProduct = productsMetadata === null || productsMetadata === void 0 ? void 0 : productsMetadata.freeHighlightedProduct;
  return {
    paidHighlightedProducts,
    freeHighlightedProduct
  };
};